"use client";

import React from "react";

import { iconColor } from "../colors";
import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @figma designed by Gabe Kelley, Nick Howland, Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1777))
 * @lastsynced 2026-10-29T13:49:45.146Z
 * @trackcomponent
 * @optimized using svgo:^3.3.4
 */
export const CheckOutline = createSVGIcon(
  <path
    d="m7.357 13.106 1.953 2.512a.715.715 0 0 0 1.114.016l6.219-7.528M.857 12a11.143 11.143 0 1 0 22.286 0A11.143 11.143 0 0 0 .857 12Z"
    strokeLinecap="round"
    strokeLinejoin="round"
    stroke="currentColor"
  />,
  "CheckOutline",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    color: iconColor.primary,
    className: iconCls(),
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
